import { auth, FUNCTIONS_URL } from '@/lib/firebase';
import i18n from '@/i18n/i18n';

export async function fetchFirebaseFunction(
  endpoint: string,
  init: RequestInit = {},
) {
  const user = auth.currentUser;
  if (!user) {
    throw new Error(i18n.t('services.loginRequired', { ns: 'common' }));
  }

  const token = await user.getIdToken();
  const headers = new Headers(init.headers);

  if (init.body && !headers.has('Content-Type') && !(init.body instanceof FormData)) {
    headers.set('Content-Type', 'application/json');
  }

  headers.set('Authorization', `Bearer ${token}`);

  const url = `${FUNCTIONS_URL}/${endpoint}`;
  try {
    return await fetch(url, {
      ...init,
      headers,
    });
  } catch (error) {
    if (error instanceof TypeError) {
      throw new Error(
        `Network request to Firebase function "${endpoint}" failed. The function may be unreachable, blocked by CORS, or timing out before returning a response. URL: ${url}`,
      );
    }
    throw error;
  }
}
